import { DataService, DataServiceProps } from 'api/DataService'

import { CanCreateResult, ConflictRecord } from './types'

type CheckCanCreateOptions = {
  // 'create' (default) é o pre-check do cadastro manual; 'update' é o da tela de
  // edição, onde reativar e mesclar não são saídas possíveis e o que interessa é
  // só se o documento está preso a um cadastro que a validação barra.
  context?: 'create' | 'update'
  // Obrigatório em context 'update': sem ele o cadastro que está sendo editado
  // entra na busca e conflita consigo mesmo.
  excludeUuid?: string
}

// Substitui o antigo pre-check por documento, que batia no index do v1 e por isso
// só enxergava clientes ativos: arquivado caía direto no toast de erro do servidor
// e excluído passava batido, criando cadastro novo por cima do histórico.
//
// Fail-open de propósito: se o endpoint cair, o submit segue e quem barra é a
// validação do model. O contrário — liberar porque o check falhou — é o
// único caminho que não pode existir, e ele não existe: canCreate nunca vira
// "bloqueado" por erro de rede.
export const checkCanCreate = async (
  document: string,
  foreign: boolean,
  options: CheckCanCreateOptions = {}
): Promise<CanCreateResult> => {
  const fallback: CanCreateResult = {
    canCreate: true,
    reason: null,
    allowDuplicate: false,
    records: []
  }

  const params = new URLSearchParams({
    document,
    foreign: String(foreign)
  })
  if (options.context) params.set('context', options.context)
  if (options.excludeUuid) params.set('exclude_uuid', options.excludeUuid)

  const requestOptions = {
    url: `/v3/customers/can_create?${params.toString()}`,
    type: 'GET'
  }
  // DataService não faz throw: erro de HTTP volta como objeto resolvido.
  const response = await DataService(requestOptions as DataServiceProps)

  if (response?.error || !response?.data) {
    return fallback
  }

  return {
    canCreate: response.data.can_create !== false,
    reason: response.data.reason ?? null,
    allowDuplicate: !!response.data.allow_duplicate,
    records: (response.data.records ?? []) as ConflictRecord[]
  }
}

export default checkCanCreate
